import "./participante.css";
import "./HeaderPopupComponent/models.css";
import { DynamicTabb } from "../../components/DynamicTab/DynamicTab";
import { ParticipentHeader } from "./ParticipantHeader";

export const Participate = () => {
  return (
    <>
      <div className="particcipentPage">
        <DynamicTabb />
        <ParticipentHeader />
      </div>
    </>
  );
};
